import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert } from "reactstrap";
import { Topic } from "../Models/Topic";
import { ToggleSetting, Modal, ModalHeader, ModalBody, ModalFooter } from "../../Layout";
import { TopicType } from "../Enums/TopicType";
import TopicWorkflowSelectorContainer from "./TopicWorkflows/TopicWorkflowSelector/TopicWorkflowSelectorContainer";

type Props = {
  topic: Topic;
  toggle: boolean;
  onToggle: () => void;
  onEdit: (topic: Topic, callback: () => void) => void;
};

type State = {
  topic: Topic;
  topicTypeState: boolean;
};

export class EditTopicModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      topic: this.props.topic,
      topicTypeState: this.props.topic.type === TopicType.Public
    };
  }

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const editedTopic = { ...this.state.topic, [event.target.name as any]: event.target.value };

    this.setState({
      topic: { ...editedTopic }
    });
  };

  onSaveClick = () => {
    this.props.onEdit(this.state.topic, () => this.onToggle());
  };

  onToggle = () => {
    this.setState(
      {
        topic: this.props.topic,
        topicTypeState: this.props.topic.type === TopicType.Public
      },
      () => this.props.onToggle()
    );
  };

  onTopicTypeToggle = () => {
    this.setState(
      prevState => ({
        topicTypeState: !prevState.topicTypeState
      }),
      () =>
        this.setState((prevState: State) => ({
          topic: {
            ...prevState.topic,
            type: prevState.topicTypeState ? TopicType.Public : TopicType.Private
          }
        }))
    );
  };

  render() {
    return (
      <Modal width="1000px" height="700px" isOpen={this.props.toggle} onToggle={this.onToggle}>
        <ModalHeader toggle={this.onToggle}>Edit Topic</ModalHeader>
        <ModalBody>
          <Form
            onSubmit={e => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <FormGroup>
              <Label for="topic-name">Topic Name</Label>
              <Input
                type="text"
                id="topic-name"
                name="name"
                value={this.state.topic.name}
                onChange={this.onChange}
                autoComplete="off"
              />
            </FormGroup>
            <FormGroup>
              <ToggleSetting
                settingName="Visible to public"
                settingDescription="This changes whether this topic is visible to all users within your company or only to select users"
                state={this.state.topicTypeState}
                onToggle={this.onTopicTypeToggle}
              />
            </FormGroup>
            <FormGroup>
              <Label for="topic-description">Topic Description</Label>
              <Input
                rows="7"
                type="textarea"
                id="topic-description"
                name="description"
                value={this.state.topic.description}
                onChange={this.onChange}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onSaveClick}>
            Save
          </Button>
          <Button onClick={this.onToggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    );
  }
}
